export var UserStatus = {
  LOGGED_IN: 'logged in',
  SOFT_LOGGED_IN: 'soft logged in',
  LOGGED_OUT: 'logged out'
};